// These pages are meant to be hosted as an <iframe> in a consumer (partner) app, so the only way
// to report the outcome of the flow is a postMessage back to the hosting window — there's no
// redirect or callback URL involved. The link token doesn't carry the partner's origin (no such
// claim is minted yet), so we broadcast with '*'; the payload itself carries no sensitive data.
export type InternalAccountFlow = 'add' | 'verify';
export type InternalAccountKind = 'plaid' | 'card';

export type InternalAccountOutcome =
  | { flow: InternalAccountFlow; kind: InternalAccountKind; status: 'success'; accountId: string }
  | { flow: InternalAccountFlow; kind: InternalAccountKind; status: 'error'; message: string }
  | { flow: InternalAccountFlow; kind: InternalAccountKind; status: 'cancelled' };

export function notifyParent(outcome: InternalAccountOutcome) {
  if (window.parent === window) return;
  window.parent.postMessage({ type: 'melio:accounts:internal', ...outcome }, '*');
}
